import { toast } from 'sonner';

import { translate } from '@shared/i18n';

/**
 * Confirmation step for removing a downloaded issue -- a toast with an
 * explicit "Remove" action rather than a native `confirm()` (matches this
 * app's existing toast-based UI instead of a blocking browser dialog).
 * `onConfirm` only runs if the reader clicks "Remove"; dismissing or
 * ignoring the toast (it auto-dismisses) does nothing, same as cancelling
 * a native confirm.
 */
export function confirmRemoveDownloadedIssue(onConfirm: () => void): void {
	toast(translate('downloadedIssue.confirmRemove'), {
		description: translate('downloadedIssue.confirmRemoveBody'),
		action: {
			label: translate('downloadedIssue.remove'),
			onClick: onConfirm,
		},
		cancel: {
			label: translate('common.cancel'),
			onClick: () => {},
		},
	});
}
